/*
 * @ Тулл для единовременной отписки всех подписок
 *
 * Для использования необходимо
 * 1. Унаследовать
 * 2. super в constructor
 * 3. super в ngOnDestroy
 * 4. takeUntil(destroy$) в pipe у подписки, которая не http запрос
 */

import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
/**TODO: Destroyer нужно переписать
он используется как предок и в компонентах и в сервисах,
но не имеет декоратора*/

@Component({
  template: ''
})

export abstract class Destroyer implements OnDestroy {
  public destroy$: Subject<boolean> = new Subject<boolean>();

  public ngOnDestroy(): void {
    // Отказываемся от подписки на все использованные takeUntil
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
